import { render } from "./AdminStartDilemmas.vue?vue&type=template&id=76a4701a&scoped=true"
import script from "./AdminStartDilemmas.vue?vue&type=script&lang=js"
export * from "./AdminStartDilemmas.vue?vue&type=script&lang=js"

import "./AdminStartDilemmas.vue?vue&type=style&index=0&id=76a4701a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76a4701a"]])

export default __exports__